import useHTTP from  '@/components/hooks/useHTTP';
import { tableOrder } from  '@/helpers/PlannerSettings';
import { sortByTable } from  '@/interfaces/plannerSettings';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router";
import TableHeading from './TableHeading';
import { useLocation } from 'react-router';
import { ToastData } from  '@/interfaces/LockerDetails';
import ToastNotification, { ToastMessageType } from '../global/ToastNotification';
import { IloadingType, PlannerSettingsContext } from '@/context/PlannerSettingsContext';
import usePlannerSettings from  '@/components/hooks/usePlannerSettings';

export interface ICalendar {    
    id:number,
    name:string,
    hexCode:string
}

const Calendars = () => {

    const [loadingLocal, setLoadingLocal] = useState<boolean>(null)
    const [cals, setCals] = useState<ICalendar[]>([]);
    const [calsOrder, setCalsOrder] = useState<sortByTable>({field:"", order:null, fieldType:null});
    const [toast, setToast] = useState<ToastData>({show: false, type: undefined, message:undefined});
    const { get } = useHTTP();
    const {search} = useLocation();
    const {permissions, setLoading, setLoadingType} = useContext(PlannerSettingsContext);
    const {loadingPerm} = usePlannerSettings();

    useEffect(() => {

        // User groups
        setLoadingLocal(true)
        setLoadingType(IloadingType.loading)

        get(`planner/calendar`).then(({data}) => {

            if (data.calendars){
                setCals(data.calendars)
            }
            
        }).finally(() => {
            setLoadingLocal(false)
        })

    }, [])

    // Handle multiple loadings
    useEffect(() => {

        if (loadingPerm || loadingLocal){
            setLoading(true)
        }
        else if (!loadingPerm && !loadingLocal){
            setLoading(false)
        }

    }, [loadingPerm, loadingLocal])

    useEffect(() => {

        if (!search) return 

        if (search.indexOf("saved") === 1){

            const params = new URLSearchParams(search);

            let msg = "";

            if (params.get("saved") === "settings"){
                msg = "Settings saved"
            }
            else if (params.get("saved") === "deleted"){
                msg = "Calendar deleted"
            }
            else if (params.get("saved") === "calsaved"){
                msg = "Calendar saved"
            }

            setToast({
                type: ToastMessageType.SUCCESS,
                message: msg,
                show: true
            })      
        }

    }, [search]);

    useEffect(() => {

        if (calsOrder.order && calsOrder.field){
            setCals(tableOrder(cals, calsOrder))
        }

    }, [calsOrder])
    

    return (
        <div className='planner-settings'>
                
            <div className='title-container main-title'>

                <h2 className='title'>Settings</h2>   
     
            </div>

            <div className='planner-settings-content'>

                <div className='sub-title-container'>

                    <h2 className='title'>Calendars</h2>

                    {permissions.canAddCalendar && 
                        <Link to={`addcalendar`}>Add New Calendar</Link> 
                    } 

                </div>

                <table className="listing-table caledars-table" cellPadding="0" cellSpacing="0">

                    <thead>
                        <tr className='heading'>
                            <TableHeading order={calsOrder} setOrder={setCalsOrder} field="name" label="Name" />
                            <th aria-label="Actions"></th>
                        </tr>
                    </thead>

                    <tbody>
                        {cals.map(item => {
                            return (
                                <tr key={item.id}>
                                    <td>
                                        <Link to={`editcalendar/${item.id}`}>{item.name}</Link>
                                    </td>
                                    <td className='edit'>
                                        <Link to={`editcalendar/${item.id}`}>View</Link>
                                    </td>
                                </tr>
                            )
                        })}

                        {cals.length === 0 && 
                            <tr>
                                <td colSpan={2} className="listing-table-empty">No calendars added</td>
                            </tr>
                        }
                    </tbody>

                </table>

            </div>

            <ToastNotification show={toast?.show} closeToast={() => setToast({...toast, show: false})} messageType={toast?.type}>
                {toast?.message}
            </ToastNotification>
        </div>
    );
};

export default Calendars;